<template>
    <div class="clearfix employee-tab">   <!-- added employee-tab here -->

        <b-alert v-model="show_message" class="position-fixed fixed-top m-0 rounded-0" style="z-index: 2000;" variant="info" dismissible>
            This is a default role and not editable.
        </b-alert>

        <b-overlay :show="showoverlay" rounded="sm">
            <b-form @submit.stop.prevent="onSubmitRoleResource">

                <div class="trz-leave-settings-wrapper">
                    <b-tabs
                        pills
                        card
                        content-class="employee-content"
                        nav-class="pr-2 m-2"
                        nav-wrapper-class="col-md-9 card no-shadow custom-margin custom-tab-nav custom-tab-nav-employee ibox ml-auto pl-0"
                    >
                        <b-tab v-for="x in data" :key="x.id">
                            <template v-slot:title>{{ x.title }}</template>
                            <div class="clearfix">
                                <div v-for="(resource, n) in x.resource" :key="resource.id">
                                    <b-form-group :label="resource.title" class="trz">
                                        <b-form-radio-group
                                            buttons
                                            button-variant="outline-primary"
                                            v-model="resource.permission"
                                            :options="resource.options"
                                            class="mb-3"
                                            :disabled="disabled"
                                            value-field="item"
                                            text-field="name"
                                            disabled-field="notEnabled"
                                            @change="updateRoleReqource(resource.id , resource.permission)"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>
                            </div>
                        </b-tab>
                    </b-tabs>
                </div>

            </b-form>
        </b-overlay>

    </div>
</template>
<!-- Abdullah26 chnaged the full tab design accroding to new tab design  -->

<script>
export default {

    mounted() {
        if (this.disabled == true)
            this.show_message = true;
    },
    props: ['role_id', 'disabled'],
    data() {

        return {
            showoverlay: false,
            show_message: false,

            data: [],
            //resources : [],
            role_title: '',

            resource_options: [
                { item: '0', name: 'No Access' },
                { item: '1', name: 'Read Access' },
                { item: '2', name: 'Write Access' },
                { item: '3', name: 'Write Access [Approval Required]', notEnabled: true }
            ],
        }
    },
    methods: {

        roleResources: function () {
            if (!this.checkNet()) return false;

            //this.role_title = role_title;

            axios.get(this.$api_url + '/acl/role/resources', {
                params: {
                    role_id: this.role_id
                }
            }).then(function (response) {
                this.data = response.data;
            }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });
        },

        updateRoleReqource: function (id, permission) {

            if (!this.checkNet()) return false;

            let currentObj = this;
            let formData = new FormData();

            formData.append('id', id);
            formData.append('permission', permission);

            axios.post(this.$api_url + '/acl/role/resources', formData)
                .then(function (response) {

                    this.$bvToast.toast('Saved!', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });


                }.bind(this))
                .catch(function (error) {
                    currentObj.serverError(error);
                });



        },

    },
    created: function () {
        this.roleResources();

    },
}
</script>
<style>
.trz .btn-outline-primary.active {
  color: #fff !important;
  background-color: #004242 !important;
  border-color: #004242!important;
}
</style>
